import { equal } from "../../../shared";
import { FavouriteItem, FavouriteItemDraft } from "../types";
import { favouriteItemToDraft } from "./favouriteItemToDraft";

export function isEqual(
  itemA: FavouriteItemDraft | FavouriteItem | undefined,
  itemB: FavouriteItemDraft | FavouriteItem | undefined
): boolean {
  if (itemA === undefined || itemB === undefined) {
    return equal(itemA, itemB);
  }

  const draftA = "id" in itemA ? favouriteItemToDraft(itemA) : itemA;
  const draftB = "id" in itemB ? favouriteItemToDraft(itemB) : itemB;

  return equal(draftA, draftB);
}
